module.exports = __webpack_public_path__ + "static/data-682416871ec615fd65b7e63f6e45a298.svg";